import * as firebase from 'firebase'

var config = {
	apiKey: "AIzaSyBeZVo0SbdXdFZZv-976RqtwfMQCLo3AXE",
	authDomain: "rbroneak-95e28.firebaseapp.com",
	databaseURL: "https://rbroneak-95e28.firebaseio.com",
	projectId: "rbroneak-95e28",
	storageBucket: "rbroneak-95e28.appspot.com",
	messagingSenderId: "928403098830",
	appId: "1:928403098830:web:1c239fd80760ed82b8149f"
};
firebase.initializeApp(config);

export default firebase;